import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

import { getProjectId } from 'utils'

export type InputProps = {}

export type Variables = {
  projectId: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const PROJECT_DATA_QUERY = gql`
  query getProject($projectId: String!) {
    getProject(projectId: $projectId) {
      projectNumber
      projectName
      projectDetails {
        company
        hourlyRate
        tax
        date
        contact
        street
        zipCode
        city
        country
        description
      }
    }
  }
`

const withProjectDataQuery = graphql<InputProps, Response, Variables, ChildProps>(
  PROJECT_DATA_QUERY,
  {
    name: 'projectData',
    options: (ownProps: any) => ({
      variables: {
        projectId: String(getProjectId(ownProps)),
      },
    }),
  },
)

export default withProjectDataQuery
